/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_S1Inputs */

const en_tut_santai_s1 = /** @type {(inputs: Tut_Santai_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a reaction from the **Kamu** bar: **Tepuk tangan**, **Terima kasih**, **Rayakan**, **Istirahat kopi**, or **Sapa**.`)
};

const id_tut_santai_s1 = /** @type {(inputs: Tut_Santai_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim reaksi dari bar **Kamu**: **Tepuk tangan**, **Terima kasih**, **Rayakan**, **Istirahat kopi**, atau **Sapa**.`)
};

/**
* | output |
* | --- |
* | "Send a reaction from the **Kamu** bar: **Tepuk tangan**, **Terima kasih**, **Rayakan**, **Istirahat kopi**, or **Sapa**." |
*
* @param {Tut_Santai_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_s1 = /** @type {((inputs?: Tut_Santai_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_s1(inputs)
	return en_tut_santai_s1(inputs)
});